(function () 
{
  angular.module('MktzapApp.Controllers')
    .controller('MassUserController', massUserController);

  massUserController.$inject = ['$scope', 'MassUserService', 'FoundationApi', 'NotificationService', 'LangService', '$rootScope'];

  function massUserController ($scope, MassUserService, FoundationApi, NotificationService, LangService, $rootScope) 
  {
    const CREATE_USERS = 0;
    const INACTIVATE_USERS = 1;

    LangService
      .getPageLabels({ 'page': 'menu.master.mass-user' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
    });

    var vm = this;
    vm.sendForm = function sendForm()
    {
      if ($('#fileUpload').val() == '') {
        NotificationService.warningHandler('', vm.labels.alertErrorNoFileSelected);
        return false;
      }
      
      var fileBase64 = $('#fileBase64').val();
      var dbAction = $("input[name='action']:checked").val();

      if (dbAction == CREATE_USERS) {
        MassUserService
          .createUsers({'fileBase64': fileBase64, 'dbAction': dbAction})
          .$promise
          .then(function (data) {
            if (data.success == false) {
              NotificationService.warningHandler(data, data.messege);
            } else {
              NotificationService.successHandler(data, vm.labels.alertSuccessCreate);
            }
          }).catch(function (data) {
            NotificationService.warningHandler(data, vm.labels.alertErrorCreate);
          })
      }

      if (dbAction == INACTIVATE_USERS) {
        MassUserService
          .inactivateUsers({'fileBase64': fileBase64, 'dbAction': dbAction})
          .$promise
          .then(function (data) {
            if (data.success == false) {
              NotificationService.warningHandler(data, data.messege);
            } else {
              NotificationService.successHandler(data, vm.labels.alertSuccessInactivate);
            }
          }).catch(function (data) {
            NotificationService.warningHandler(data, vm.labels.alertErrorInactivate);
          })
      }
    }

    //Convert CSV file to Base64 and set the value in Input Hidden
    $('input[type="file"]').on('change', function(e) {
      $('#btnSend').removeClass('disabled');
      $('#nameFileUpload').text(e.target.files[0].name);

      let file = e.target.files[0];
      let reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = function() {
        vm.setValue = reader.result;
        NotificationService.successHandler('', vm.labels.alertSuccessFileSelected);
      }
    });
  }
})();
